<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <b-card v-else>
            <h5 class="mb-0">
                <i class="fa fa-fw fa-undo mr-2" />Retur Marketplace
            </h5>
            <hr />
            <b-table
                bordered
                hover
                show-empty
                no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive
                class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada data retur marketplace.
                </template>
                <template v-slot:cell(no_faktur)="row">
                    {{ row.item.no_faktur }}
                    <div class="small text-muted">
                        Invoice: {{ row.item.invoice_no_faktur }}
                    </div>
                </template>
                <template v-slot:cell(mp_no_ref)="row">
                    {{ row.item.mp_no_ref || "-" }}
                </template>
                <template v-slot:cell(detail)="row">
                    <div class="small text-muted">
                        <strong>{{ row.item.invoice_division || "-" }}</strong>
                    </div>
                    <div class="small">
                        Refund:
                        <strong>Rp. {{ $helper.formatThousand(row.item.refund_amount) }}</strong>
                        <br />
                        Biaya:
                        <strong>Rp. {{ $helper.formatThousand(row.item.total_fee) }}</strong>
                    </div>
                </template>
                <template v-slot:cell(created)="row">
                    <div class="small">
                        {{ row.item.created_by }}
                    </div>
                    <div class="small text-muted">
                        {{ $helper.parseDate(row.item.created_at) }},
                        {{ $helper.parseHourMinute(row.item.created_at) }}
                    </div>
                </template>
                <template v-slot:cell(action)="row">
                    <router-link :to="'/marketplace/returns/' + row.item.id">
                        <b-button
                            size="sm"
                            variant="primary"
                            v-b-tooltip.hover.top
                            title="Detail Retur"
                        >
                            <i class="fa fa-fw fa-info" />
                        </b-button>
                    </router-link>
                </template>
            </b-table>
            <PageSizer
                :totalRows="totalRows"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            initStatus: 0,
            isBusy: true,

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" }
            ],

            fields: [
                { key: "no_faktur", label: "No. Faktur", sortable: false },
                { key: "mp_no_ref", label: "No. Ref Marketplace", sortable: false },
                { key: "detail", label: "Detail", sortable: false },
                { key: "created", label: "Dibuat", sortable: false },
                { key: "action", label: "Aksi" }
            ],

            items: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0
        };
    },

    methods: {
        init() {
            this.initStatus = 0;
            this.getItems()
                .then(() => {
                    this.initStatus = 1;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                    this.initStatus = -1;
                });
        },

        getItems(page = 1) {
            this.isBusy = true;
            this.items = [];

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage
            );

            return this.$axios
                .get("marketplace-returns" + param)
                .then(res => {
                    this.items = res.data.data.items;
                    this.totalRows = res.data.data.total;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        }
    },

    created() {
        this.init();
        this.$helper.toastFlash(this);
    }
};
</script>
